import { contentPadding } from '@monorepo/shared/styles/layout';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';
import { Main } from '../Main';

const Container = styled(Main)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow: hidden;
`;

const ScrollArea = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  ${contentPadding}
`;

interface ContentWithBottomDrawerProps {
  children: ReactNode;
  className?: string;
}

interface MainProps {
  children: ReactNode;
  mainRef?: React.Ref<HTMLDivElement>;
}

function ContentWithBottomDrawerMain({
  children,
  mainRef,
}: MainProps): ReactElement {
  return <ScrollArea ref={mainRef}>{children}</ScrollArea>;
}

/**
 * Flex column wrapper for page content with an in-flow BottomDrawer.
 * Use along with BottomDrawer as a sibling inside this component.
 *
 * @example
 * <ContentWithBottomDrawer>
 *   <ContentWithBottomDrawer.Main mainRef={ref}>
 *     {page content}
 *   </ContentWithBottomDrawer.Main>
 *   <BottomDrawer open={isOpen} title="Preview">
 *     {drawer content}
 *   </BottomDrawer>
 * </ContentWithBottomDrawer>
 */
export function ContentWithBottomDrawer({
  children,
  className,
}: ContentWithBottomDrawerProps): ReactElement {
  return <Container className={className}>{children}</Container>;
}

ContentWithBottomDrawer.Main = ContentWithBottomDrawerMain;
